
<div class="tile-padding-first tile-padding">
  <form [formGroup]="frmReportGenerate">
    <div class="flex-search-container" [class.filter-bar]="filtersEnabled">
      <div fxLayout="column" fxLayout.gt-md="row" fxLayoutWrap fxLayoutGap="1%" class="flex-search-sub filter-bar__group">
        <div fxLayout.gt-md="column" class="filter-bar__field">
          <div class="filter-bar__label">Start Date</div>
          <input type="date" class="field__control" formControlName="startDate" required (input)="datePreset = null"
            data-toggle="tooltip" data-placement="top" title="Please select a start date">
          @if (frmReportGenerate.controls.startDate.invalid && frmReportGenerate.controls.startDate.touched) {
            <span class="field__error">Enter Start Date</span>
          }
          </div>
          <div fxLayout.gt-md="column" class="filter-bar__field">
            <div class="filter-bar__label">End Date</div>
            <input type="date" class="field__control" formControlName="endDate" required (input)="datePreset = null"
              data-toggle="tooltip" data-placement="top" title="Please select an end date">
            @if (frmReportGenerate.controls.endDate.invalid && frmReportGenerate.controls.endDate.touched) {
              <span class="field__error">Enter End Date</span>
            }
            </div>
            <div fxLayout.gt-md="column" class="filter-bar__field">
              <div class="filter-bar__label">Report Types</div>
              <app-searchable-select formControlName="reports" [items]="reportDataService.reports"
                displayField="name" placeholder="Select a report type"
                searchPlaceholder="Search report types…"></app-searchable-select>
            </div>
            @if (batchPdfEnabled) {
              <div fxLayout.gt-md="column" class="filter-bar__field">
                <app-report-format-picker testId="batch-format" [(format)]="batchFormat"
                  [pdfAvailable]="isNativeReportSelected"></app-report-format-picker>
              </div>
            }
            @if (!filtersEnabled) {
              <div fxLayout.gt-md="column">
                <div class="btn-align">
                  <span><button class="btn btn-primary" name="View" value="View" (click)="generateReportList()">Generate</button></span>
                </div>
              </div>
            }
          </div>
          @if (filtersEnabled) {
            <div class="filter-bar__actions">
              <div class="filter-bar__presets">
                <app-date-presets [selected]="datePreset" (presetSelected)="onDatePreset($event)"></app-date-presets>
              </div>
              <div class="filter-bar__buttons">
                <app-filter-clear-all (clear)="clearAll()"></app-filter-clear-all>
                <button class="btn btn-primary" name="View" value="View" (click)="generateReportList()">Generate</button>
              </div>
            </div>
          }
        </div>
        <mat-expansion-panel hideToggle="true" class="custom-header" [expanded]="false">
          <mat-expansion-panel-header [collapsedHeight]="'48px'" [expandedHeight]="'48px'">
            <mat-panel-title>
              More Options
            </mat-panel-title>
            <mat-panel-description>
              &nbsp;
              <mat-icon>
                <i class="tw:ml-2">
                  <svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="sliders-h" role="img"
                    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-sliders-h fa">
                    <path fill="currentColor"
                      d="M504 384H192v-40c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v40H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h88v40c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-40h312c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm-344 64h-32v-96h32v96zM504 96H256V56c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v40H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h152v40c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-40h248c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm-280 64h-32V64h32v96zm280 80h-88v-40c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v40H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h312v40c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-40h88c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm-120 64h-32v-96h32v96z"
                    class=""></path>
                  </svg>
                </i>
              </mat-icon>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="flex-search-container">
            <div fxLayout="column" fxLayout.gt-md="row" fxLayoutWrap fxLayoutGap="1%" class="flex-search-sub">
              <div fxLayout.gt-md="column">
                <div>Clients</div>
                <app-searchable-select formControlName="clients" [items]="reportDataService.clientList"
                  displayField="dropdownDisplay" valueField="clientId" placeholder="Select a client"
                  searchPlaceholder="Search clients…" (selectionChange)="onClientSelected($event)"></app-searchable-select>
              </div>
              @if (brandList.length > 1) {
                <div fxLayout.gt-md="column">
                  <div>Brand</div>
                  <app-searchable-select formControlName="brands" [items]="brandList"
                    displayField="name" valueField="companyId" multiple
                    placeholder="All brands" searchPlaceholder="Search brands…"></app-searchable-select>
                </div>
              }
              <div fxLayout.gt-md="column">
                <div>Tuition Coordinator</div>
                <app-searchable-select formControlName="coordinators" [items]="reportDataService.coordinatorList"
                  displayField="name" valueField="id" placeholder="Select a tuition coordinator"
                  searchPlaceholder="Search coordinators…"></app-searchable-select>
                <app-report-lookup-note lookup="coordinators" label="coordinators"></app-report-lookup-note>
              </div>
              <div fxLayout.gt-md="column">
                <div>Tutors</div>
                <app-searchable-select formControlName="tutors" [items]="reportDataService.tutorList"
                  displayField="name" valueField="id" placeholder="Select a tutor"
                  searchPlaceholder="Search tutors…"></app-searchable-select>
                <app-report-lookup-note lookup="tutors" label="tutors"></app-report-lookup-note>
              </div>
              <div fxLayout.gt-md="column">
                <div>Learners</div>
                <app-searchable-select formControlName="students" [items]="reportDataService.studentList"
                  displayField="name" valueField="id"
                  multiple
                  placeholder="Select a learner" searchPlaceholder="Search learners…"></app-searchable-select>
                <app-report-lookup-note lookup="students" label="learners"></app-report-lookup-note>
              </div>
              <div fxLayout.gt-md="column">
                <div class="tw:invisible">&nbsp;</div>
                <span><button class="btn btn-primary" type="button" name="View" value="View" (click)="clearMoreOptions()">Clear filters</button></span>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </form>
    </div>
    <label class="tw:text-danger">{{errorMsg}}</label>

    @if (recordCount !== null) {
      <app-data-table
        [columns]="columns"
        [data]="reportRows"
        [pageSize]="10"
        [rowStyle]="rowStyle"
        emptyMessage="No records found">
        <ng-template appColumnCell="sendReport" let-row>
          <label class="field__checkbox"><input type="checkbox" [disabled]="row.reportRequired.toLowerCase() == 'no'" [checked]="row.reportRequired.toLowerCase() == 'yes'" (change)="processSendReportRowCLick(row, {checked: $event.target.checked})" /> Send report</label>
        </ng-template>
      </app-data-table>
    }
    @if (recordCount > 0) {
      <div class="btn-align">
        <span><button class="btn btn-primary tw:mr-1" name="btnSend" value="Send" data-test="send-reports" (click)="sendReports()" [disabled]="sendReportList.length === 0">{{ sendReportsLabel }}</button></span>
      </div>
    }